/* Hero slider — cross-fading full-bleed slides for sections/home-hero.liquid.

   Loaded only when the hero has more than one block, so a single-slide hero
   never pays for it.

   Autoplay stops whenever the visitor is engaged with the hero or cannot see
   it: pointer over it, keyboard focus inside it, or the tab in the background.
   A carousel that keeps moving while someone is reading a headline or tabbing
   to its button is a usability fault, not a feature — and a timer left running
   in a hidden tab makes the slide jump the moment they return. */
(function () {
  function init(root) {
    if (!root || root.dataset.heroWired) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;
    root.dataset.heroWired = '1';

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var every = (parseFloat(root.getAttribute('data-autoplay')) || 0) * 1000;
    /* Honour the OS setting rather than the theme's: a visitor who asks for
       reduced motion gets the first slide and the dots, never a timer. */
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var at = 0;
    var timer = null;

    /* Slides past the first ship data-src; promote on first reveal. */
    function promote(slide) {
      var img = slide.querySelector('img[data-src]');
      if (!img) { return; }
      if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    }

    function show(n) {
      at = (n + slides.length) % slides.length;
      promote(slides[at]);
      slides.forEach(function (s, i) {
        var on = i === at;
        s.classList.toggle('is-on', on);
        /* Inactive slides leave the a11y tree AND the tab order — otherwise a
           screen reader reads every season's headline in sequence, and their
           buttons stay tabbable underneath the visible one. aria-hidden alone
           does the first half only, which strands focus on an invisible button;
           inert does both, with aria-hidden kept as the older-browser fallback. */
        if (on) {
          s.removeAttribute('aria-hidden');
          s.removeAttribute('inert');
        } else {
          s.setAttribute('aria-hidden', 'true');
          s.setAttribute('inert', '');
        }
      });
      /* Keyed on each dot's own index, never on its position in the list: the
         indicator lives inside the glass pane, so every slide carries a full
         set and a flat 0..n-1 walk would mark the wrong dots from the second
         set on. */
      dots.forEach(function (d) {
        d.setAttribute('aria-current', Number(d.getAttribute('data-hero-dot')) === at ? 'true' : 'false');
      });
      /* One-slide lookahead: promoting only on reveal started a 300KB+ fetch
         at the same instant as the crossfade, so the incoming slide faded in
         as a bare glass pane over the page background and the photo popped in
         whenever the network finished. Promoting the next slide now gives its
         image the whole dwell time to arrive. */
      promote(slides[(at + 1) % slides.length]);
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!every || still) return;
      /* The visibilitychange listener below lives on document and outlives this
         section, so a Theme Editor edit would otherwise leave the previous
         instance's timer ticking against detached slides forever. */
      if (!root.isConnected) return;
      timer = setInterval(function () { show(at + 1); }, every);
    }

    dots.forEach(function (d) {
      var target = Number(d.getAttribute('data-hero-dot'));
      d.addEventListener('click', function () { show(target); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    show(0);
    start();
  }

  function boot() { init(document.querySelector('[data-hero]')); }

  /* The Theme Editor swaps the section's markup when a slide is edited, which
     drops the old element (and its flag) and needs the new one wired. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) init(e.target.querySelector('[data-hero]'));
  });

  boot();
})();
